import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND_NAME, DEFAULT_OG_IMAGE, absoluteUrl } from '../seo';

function Terms() {
  const pageUrl = absoluteUrl('/terms-and-conditions');
  const pageTitle = 'Terms and Conditions';
  const pageDescription = 'Review the Apex Breath terms and conditions for app usage, subscriptions, and disclaimers.';

  return (
    <section className="basic-page">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <h1>Terms and Conditions</h1>
      <p>By using Apex Breath, you agree to use the app responsibly and in accordance with applicable laws.</p>
      <h2>License</h2>
      <p>You receive a limited, non-transferable license for personal, non-commercial use.</p>
      <h2>Subscriptions</h2>
      <p>Paid plans renew automatically unless canceled through your App Store subscription settings.</p>
      <h2>Health Disclaimer</h2>
      <p>Apex Breath is not medical advice. Consult a physician before beginning new breathing practices.</p>
      <h2>Contact</h2>
      <p>Questions: troy@merokeeventures.com</p>
    </section>
  );
}

export default Terms;
